import { routes } from "./utils.routes";
import { getContentMediaAttachment } from "./contentMedia";

export type ContentDetailConfig = {
  backHref: string;
  backLabel: string;
  eyebrow: string;
  typeBadge: string;
};

export function getContentDetailConfig(item: {
  type?: string;
  category?: string;
}): ContentDetailConfig {
  const type = item.type || "article";
  if (type === "event") {
    return {
      backHref: routes.EVENTS,
      backLabel: "Retour aux événements",
      eyebrow: "Événements",
      typeBadge: "Événement",
    };
  }
  if (type === "activity") {
    return {
      backHref: `${routes.ARTICLES}/activite`,
      backLabel: "Retour aux activités",
      eyebrow: "Activités",
      typeBadge: "Activité",
    };
  }
  return {
    backHref: routes.ARTICLES,
    backLabel: "Retour aux actualités",
    eyebrow: "Actualités",
    typeBadge: item.category || "Article",
  };
}

export function extractContentAttachment(item: {
  attachmentType?: string | null;
  attachmentUrl?: string | null;
  location?: string;
  content?: string;
}): string | null {
  const media = getContentMediaAttachment(item);
  return media?.attachmentUrl || null;
}
